const inquiryTypes = [
  {
    value: 'Generell henvendelse',
    label: 'Generell henvendelse',
    title: 'Kontakt oss',
    intro:
      'Vennligst gi oss beskjed om eventuelle problemer du opplever og vi vil besvare henvendelsen din så fort vi kan.',
    desc: 'Beskrivelse',
  },
  {
    value: 'Tilbakemelding',
    label: 'Tilbakemelding',
    title: 'Hva syns du om nye Boligmappa?',
    intro:
      'Vi setter veldig stor pris på din tilbakemelding og jobber kontinuerlig med å bli bedre.',
    desc: 'Tilbakemelding',
    descriptionPlaceholder:
      'Fortell oss hva du liker/misliker og eventuelt hva du savner.',
  },
];

export default inquiryTypes;
